import React, { useState, useEffect } from 'react'
import BlogContent from './BlogContent'
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import ListItemText from '@mui/material/ListItemText';
import ListItem from '@mui/material/ListItem';
import List from '@mui/material/List';
import Divider from '@mui/material/Divider';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import CloseIcon from '@mui/icons-material/Close';
import Slide from '@mui/material/Slide';
import parser from 'html-react-parser'
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormHelperText from '@mui/material/FormHelperText';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import { getCategories } from '../services/CategoryService';
import { addBlog } from '../services/BlogService';
import { styled } from '@mui/material/styles';
import Chip from '@mui/material/Chip';
import Paper from '@mui/material/Paper';
import TextField from '@mui/material/TextField';
import { useCookies } from 'react-cookie'
import { useNavigate } from 'react-router-dom';
import '../style/blog.css'
import { CircularProgress } from '@mui/material';

const TagListItem = styled('li')(({ theme }) => ({
  margin: theme.spacing(0.5),
}));

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});


export default function PublishBlog() {
    const [content, setContent] = useState("")
    const [open, setOpen] = useState(false)
    const [cookies, setCookies, removeCookies] = useCookies()
    const [category, setCategory] = useState('')
    const [categories, setCategories] = useState([])
    const [isLoading, setIsLoading] = useState(false)
    const [tags, setTags] = useState([])
    const navigate = useNavigate()

    useEffect(()=>{
      getCategories().then(res=>{
        console.log(res.data)
        setCategories(res.data)
      }).catch(err => console.log(err))
    }, [])

    const handleCategoryChange = (event) => {
      setCategory(event.target.value);
    }

    const handleClose = () => {
      setOpen(false);
    }

    const handleDelete = (tagToDelete) => () => {
      setTags((_tags) => _tags.filter((tag) => tag !== tagToDelete));
    }

    const createTokenHeader = () =>{
      if(!cookies['accessToken']){
          navigate('/login')
          return
      }
      const token = cookies['accessToken'].access_token
      const _headers = {"Authorization" : `Bearer ${token}`}
      return _headers
  }

    const handlePublish = () =>{
      setIsLoading(true)
      const _headers = createTokenHeader()

      const blog = {
        // title: "A",
        content: content,
        tags: tags,
        category: category
      }

      addBlog(blog, _headers)
      .then((res)=>{
          console.log(res)
          if(res.status == 201){
            console.log("Blog Uploaded")
            navigate("/blogs/"+res.data)
          }
          setIsLoading(false)
        } 
      )
      .catch((err)=>{
        console.log("Failed to upload blog " + err)
        setIsLoading(false)
      })
    }

    const addTag = (event) =>{
      const tag = event.target.value
      if(event.keyCode == 13){
        if(tags.length < 5 && !tags.includes(tag)){
          setTags([...tags, tag]);
        }
        event.target.value = ""
      }
    }

  return (
    <>
        <BlogContent setOpen={setOpen} setContent={setContent}/>
        <div>
      <Dialog
        fullScreen
        open={open}
        onClose={handleClose}
        TransitionComponent={Transition}
      >
        <AppBar sx={{ position: 'relative' }}>
          <Toolbar>
            <IconButton
              edge="start"
              color="inherit"
              onClick={handleClose}
              aria-label="close"
            >
              <CloseIcon />
            </IconButton>
            <Typography sx={{ ml: 2, flex: 1 }} variant="h6" component="div">
              Preview
            </Typography>
            <Button autoFocus color="inherit" disabled={isLoading} onClick={handlePublish}>
              Publish
            </Button>
          </Toolbar>
        </AppBar>
        {isLoading && <CircularProgress sx={{marginTop: "1em", alignSelf: "center"}} />}
        <List>
        <ListItem>
            <FormControl sx={{ m: 1, minWidth: 120 }}>
            <InputLabel id="demo-simple-select-helper-label">Category</InputLabel>
            <Select
              labelId="demo-simple-select-helper-label"
              id="demo-simple-select-helper"
              value={category}
              label="Category"
              onChange={handleCategoryChange}
            >{
              categories &&
              categories.map(category=>(
                <MenuItem value={category.categoryName} key={category._id}>{category.categoryName}</MenuItem>
              ))
            }
            </Select>
            <FormHelperText>Choose category for your blog</FormHelperText>
          </FormControl>
          </ListItem>
          <Divider />
          <ListItem style={{display: 'flex', gap: '2em'}}>
            <div>
              <TextField
                id="standard-helperText"
                label="Tags"
                helperText="Upto 5 tags can be added for a blog"
                variant="standard"
                onKeyDown={addTag}
              />
            </div>
            {tags &&
              <div>
                  <Paper
                      sx={{
                        display: 'flex',
                        justifyContent: 'left',
                        flexWrap: 'wrap',
                        listStyle: 'none',
                        p: 0.5,
                        m: 0,
                      }}
                      component="ul"
                    >
                      {tags.map((tag) => {
                        return (
                          <TagListItem key={tag}>
                            <Chip
                              label={tag}
                              onDelete={handleDelete(tag)}
                            />
                          </TagListItem>
                        );
                      })}
                    </Paper>
              </div>
            } 
          </ListItem>
            <Divider />
          <div className='ProseMirror'>
            <ListItem>
            <ListItemText
              primary= {parser(content)}
            />
          </ListItem>
          </div>
        </List>
      </Dialog>
    </div>
    </>
  )
}
